import { render, staticRenderFns } from "./UTable.vue?vue&type=template&id=1f4f45ff&"
import script from "./UTable.vue?vue&type=script&lang=js&"
export * from "./UTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports